import { Avatar } from "@via/components/avatar.tsx";
import TagsCell from "@via/components/tags-cell.tsx";
import { formatDateString } from "@via/utils/helpers.tsx";
import { type JSX } from "react";
import { Link } from "react-router-dom";

export default function ActivityCard({ item, icon, href }): JSX.Element {
  return (
    <Link to={href}>
      <div className="activity-card">
        <div className="flex flex-row justify-between">{icon}</div>
        <div className="flex flex-col">
          <span className="truncate text-sm">{item.name}</span>
          <div className="my-2 w-full border-t border-gray-300" />
          <span className="truncate text-[10px]">
            Created by: {item.ownerName}
          </span>
          <span className="truncate text-[10px]">
            Last Modified: {formatDateString(item.modifiedAt, "LL")}
          </span>
        </div>
        <div className="flex flex-row items-center justify-between">
          <Avatar name={item.ownerName} notifications={false} />
          <TagsCell tags={item.tags ?? []} rowId={item.id} variant="card" />
        </div>
      </div>
    </Link>
  );
}
